import ReservationFilterBar from "../../components/reservation_v2/filters/ReservationFilterBar";
import Reservations from "../../components/reservation_v2/Reservations";

const ReservationsPage = () => {
  return (
    <>
      <ReservationFilterBar />
      <Reservations />
    </>
  );
};

export default ReservationsPage;
